"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysIncluded = exports.formatDateDayMonDDYYYY = exports.convertUTCtoLocal = exports.getDateDaysAgo = exports.formatActivityDate = exports.makeCompactDate = exports.formatDate3 = exports.formatDateForStatsList = exports.formatDate2 = exports.formatDate = exports.formatAMPM = exports.TIME_PICKER = exports.MONTHS_SHORT = exports.MONTHS_LONG = exports.MONTHS = void 0;
exports.MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
exports.MONTHS_LONG = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
exports.MONTHS_SHORT = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
exports.TIME_PICKER = [
    "12:00am",
    "12:15am",
    "12:30am",
    "12:45am",
    "1:00am",
    "1:15am",
    "1:30am",
    "1:45am",
    "2:00am",
    "2:15am",
    "2:30am",
    "2:45am",
    "3:00am",
    "3:15am",
    "3:30am",
    "3:45am",
    "4:00am",
    "4:15am",
    "4:30am",
    "4:45am",
    "5:00am",
    "5:15am",
    "5:30am",
    "5:45am",
    "6:00am",
    "6:15am",
    "6:30am",
    "6:45am",
    "7:00am",
    "7:15am",
    "7:30am",
    "7:45am",
    "8:00am",
    "8:15am",
    "8:30am",
    "8:45am",
    "9:00am",
    "9:15am",
    "9:30am",
    "9:45am",
    "10:00am",
    "10:15am",
    "10:30am",
    "10:45am",
    "11:00am",
    "11:15am",
    "11:30am",
    "11:45am",
    "12:00pm",
    "12:15pm",
    "12:30pm",
    "12:45pm",
    "1:00pm",
    "1:15pm",
    "1:30pm",
    "1:45pm",
    "2:00pm",
    "2:15pm",
    "2:30pm",
    "2:45pm",
    "3:00pm",
    "3:15pm",
    "3:30pm",
    "3:45pm",
    "4:00pm",
    "4:15pm",
    "4:30pm",
    "4:45pm",
    "5:00pm",
    "5:15pm",
    "5:30pm",
    "5:45pm",
    "6:00pm",
    "6:15pm",
    "6:30pm",
    "6:45pm",
    "7:00pm",
    "7:15pm",
    "7:30pm",
    "7:45pm",
    "8:00pm",
    "8:15pm",
    "8:30pm",
    "8:45pm",
    "9:00pm",
    "9:15pm",
    "9:30pm",
    "9:45pm",
    "10:00pm",
    "10:15pm",
    "10:30pm",
    "10:45pm",
    "11:00pm",
    "11:15pm",
    "11:30pm",
    "11:45pm",
];
const SHORT_DAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const formatAMPM = (incomingDate, capitalized = true) => {
    const date = (0, exports.convertUTCtoLocal)(incomingDate);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? (capitalized ? "PM" : "pm") : capitalized ? "AM" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? 0 + minutes : minutes;
    let strTime = hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + " " + ampm;
    return strTime;
};
exports.formatAMPM = formatAMPM;
function formatDate(incomingDate) {
    const date = (0, exports.convertUTCtoLocal)(incomingDate);
    const months = exports.MONTHS_LONG;
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedDate = `${month} ${day} • ${formatHours(hours)}:${formatMinutes(minutes)} ${ampm}`;
    return formattedDate;
}
exports.formatDate = formatDate;
function formatDate2(incomingDate, includeTime = true) {
    const date = (0, exports.convertUTCtoLocal)(incomingDate);
    const months = exports.MONTHS_SHORT;
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const today = new Date();
    const isToday = date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    const dateText = isToday ? "Today" : `${month} ${day}`;
    const dayText = SHORT_DAY[date.getDay()];
    // const dayAndDate = isToday ? "Today" : `${dayText} • ${dateText}`;
    const dayAndDate = isToday ? "Today" : `${dayText}, ${dateText}`;
    const formattedDate = dayAndDate +
        (isToday || includeTime
            ? `, ${formatHours(hours)}:${formatMinutes(minutes)} ${ampm}`
            : "");
    return formattedDate;
}
exports.formatDate2 = formatDate2;
function formatDateForStatsList(date, includeTime = true) {
    const month = exports.MONTHS_SHORT[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    const today = new Date();
    const isToday = date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    const dateText = isToday ? "Today" : `${month} ${day}`;
    return `${dateText} • ${formatHours(hours)}:${formatMinutes(minutes)}${ampm}`;
}
exports.formatDateForStatsList = formatDateForStatsList;
// Mar 12, 2023
function formatDate3(incomingDate, includeTime = false) {
    // For date-only values (no time component), skip timezone conversion
    const date = incomingDate.getHours() === 0 && incomingDate.getMinutes() === 0
        ? incomingDate
        : (0, exports.convertUTCtoLocal)(incomingDate);
    const months = exports.MONTHS_SHORT;
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const year = date.getFullYear();
    const ampm = hours >= 12 ? "PM" : "AM";
    const today = new Date();
    const isToday = date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    const dateText = (isToday ? "Today" : `${month} ${day}, ${year}`) +
        (isToday || includeTime
            ? `, ${formatHours(hours)}:${formatMinutes(minutes)} ${ampm}`
            : "");
    return dateText;
}
exports.formatDate3 = formatDate3;
function formatHours(hours) {
    return hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
}
function formatMinutes(minutes) {
    return minutes < 10 ? `0${minutes}` : minutes.toString();
}
function makeCompactDate(date) {
    // Check if date is valid
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        return "00/00/0000";
    }
    // Get individual date components
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    // Concatenate components with slashes
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
}
exports.makeCompactDate = makeCompactDate;
function formatActivityDate(incomingDate) {
    const date = (0, exports.convertUTCtoLocal)(incomingDate);
    const months = exports.MONTHS_SHORT;
    const month = months[date.getMonth()];
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    const today = new Date();
    const isToday = date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    const dayText = SHORT_DAY[date.getDay()];
    const dateText = isToday ? "Today" : dayText;
    const formattedDate = dateText + ` • ${month} ${day}`;
    return formattedDate;
}
exports.formatActivityDate = formatActivityDate;
function getDateDaysAgo(daysAgo) {
    const currentDate = new Date();
    const pastDate = new Date(currentDate);
    pastDate.setDate(currentDate.getDate() - daysAgo);
    return pastDate;
}
exports.getDateDaysAgo = getDateDaysAgo;
//should only be used in the clients
const convertUTCtoLocal = (theDate) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localDate = new Date(theDate.toLocaleString("en-US", {
        timeZone: timeZone,
    }));
    return localDate;
};
exports.convertUTCtoLocal = convertUTCtoLocal;
const formatDateDayMonDDYYYY = (date) => {
    const options = {
        weekday: "short",
        month: "short",
        day: "2-digit",
        year: "numeric",
    };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate;
};
exports.formatDateDayMonDDYYYY = formatDateDayMonDDYYYY;
const daysIncluded = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    // Set the time to midnight for both dates
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    // Calculate the difference in milliseconds
    const diffInMs = end.getTime() - start.getTime();
    // Calculate the number of days
    const daysDiff = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    return daysDiff;
};
exports.daysIncluded = daysIncluded;
